"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculatorContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _context = require("../../context");
var _useCalculator = require("./hooks/useCalculator");
var _Container = require("../../components/Container");
var _Fields = require("../../components/Fields");
var _ProgramTable = require("../../components/ProgramTable");
var _OffersNotFound = require("../../components/OffersNotFound");
var _Banner = require("../../components/Banner");
var _ProgramModal = require("../../components/ProgramModal");
var _ProgramDescriptionContainer = require("../ProgramDescriptionContainer/ProgramDescriptionContainer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CalculatorContainer = () => {
  const {
    title,
    subtitle,
    priceTooltipTitle,
    priceTooltipText,
    escrowTooltipText,
    escrowTooltipTitle
  } = (0, _context.useAppContext)();
  const {
    fields,
    programs,
    selectedProgram,
    selectProgram,
    resetSelectedProgram,
    trackMortgageButtonClick,
    trackMortgageModalButtonClick,
    trackMortgageOnlineLabelClick,
    trackNoOfferClick
  } = (0, _useCalculator.useCalculator)();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Container.Container, {
    title: title,
    subtitle: subtitle,
    fields: /*#__PURE__*/React.createElement(_Fields.Fields, (0, _extends2.default)({}, fields, {
      priceTooltipTitle: priceTooltipTitle,
      priceTooltipText: priceTooltipText,
      escrowTooltipTitle: escrowTooltipTitle,
      escrowTooltipText: escrowTooltipText
    })),
    programs: programs.length ? /*#__PURE__*/React.createElement(_ProgramTable.ProgramTable, {
      items: programs,
      onProgramSelect: selectProgram,
      onLabelClick: trackMortgageOnlineLabelClick,
      showEscrow: fields.showEscrow
    }) : /*#__PURE__*/React.createElement(_OffersNotFound.OffersNotFound, {
      onMortgageLinkClick: trackNoOfferClick
    }),
    banner: /*#__PURE__*/React.createElement(_Banner.Banner, {
      onButtonClick: trackMortgageButtonClick
    })
  }), selectedProgram && /*#__PURE__*/React.createElement(_ProgramModal.ProgramModal, (0, _extends2.default)({}, selectedProgram, {
    showEscrow: fields.showEscrow,
    onClose: resetSelectedProgram,
    onMortgageButtonClick: trackMortgageModalButtonClick,
    description: /*#__PURE__*/React.createElement(_ProgramDescriptionContainer.ProgramDescriptionContainer, {
      description: selectedProgram.description
    })
  })));
};
exports.CalculatorContainer = CalculatorContainer;